import React, { useEffect, useState } from 'react';
import { ReportContextMenu } from '../ReportContextMenu';
import { HiddenSectionDialog } from '../HiddenSectionDialog';
import { BirdActionMenu } from '../BirdActionMenu';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReportSection } from '../ReportSection';
import { useContextMenuHandlers } from '../hooks';
import { ExplanationInfoDialog } from '../ExplanationInfoDialog';
import { ManageColumnsDialog } from '../ManageColumnsDialog';
//css
import cn from './ReportContainer.css.json';
import './ReportContainer.css';
export const ReportPageContainerBase = ({ onPageLoad, state, contextMenuActions, }) => {
    const [hasOnLoadFired, setHasOnLoadFired] = useState(false);
    useEffect(() => {
        if (!hasOnLoadFired && onPageLoad && state.sectionData) {
            onPageLoad();
            setHasOnLoadFired(true);
        }
    }, [hasOnLoadFired, onPageLoad, state.sectionData]);
    const { onContextMenu, onKeyDown } = useContextMenuHandlers(contextMenuActions.open);
    if (!state.sectionData) {
        return null;
    }
    else {
        return (React.createElement("div", { className: cn.reportContainerWrapper },
            React.createElement("div", { className: cn.reportContainerInner, onContextMenu: onContextMenu, onKeyDown: onKeyDown },
                React.createElement(ReportSection, { data: state.sectionData }),
                React.createElement(ReportContextMenu, null),
                React.createElement(HiddenSectionDialog, { onContextMenu: onContextMenu }),
                React.createElement(BirdActionMenu, null),
                React.createElement(ExplanationInfoDialog, null),
                React.createElement(ManageColumnsDialog, null))));
    }
};
export const ReportPageContainer = connect((state) => {
    const currentSection = state.sections.currentSection;
    return {
        state: {
            sectionData: (currentSection && state.sections.byId[currentSection]) || undefined,
        },
    };
}, (dispatch) => ({
    contextMenuActions: bindActionCreators(ReportContextMenuState.actions, dispatch),
}))(ReportPageContainerBase);
